import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { ListFill } from '@lyearn/icons';
import { Fields, FieldType } from '@/components/Form';
import VisibilitySettingsFormField from '@/components/Form/components/VisibilitySettings';
import { VisibilitySettingsFormFieldProps } from '@/components/Form/components/VisibilitySettings/types';

export const INITIAL_VALUES = {
  name: '',
};

export type FolderEditorFormValues = typeof INITIAL_VALUES;

const VISIBILITY_SETTINGS_CONTAINER_OVERRIDES: VisibilitySettingsFormFieldProps['overrides'] = {
  restrictedContent: {
    overrides: {
      label: { variant: 'body-short-02' },
      addButton: { className: 'mt-6' },
    },
  },
};

export const getFormFields = (t: TFunction): Fields<FolderEditorFormValues> => {
  return {
    name: {
      name: 'name',
      label: t('Common:Name'),
      placeholder: 'Give a name to the Project',
      type: FieldType.Text,
      size: 'large',
      props: {
        startAdornment: <ListFill />,
      },
    },
    visibilitySettings: {
      name: 'visibilitySettings',
      label: t('VisibilitySetting:VisibleTo'),
      type: FieldType.Custom,
      Component: ({ value, onChange }) => (
        <VisibilitySettingsFormField
          overrides={VISIBILITY_SETTINGS_CONTAINER_OVERRIDES}
          type="users_and_groups"
          value={value}
          onChange={onChange}
        />
      ),
    },
  };
};

export const FORM_LAYOUT = ['name', 'visibilitySettings'];
